import React, { FC, useState } from 'react'
import { Button, Input, Select, Form, Radio } from 'antd';
import { RefreshIcon, ResetIcon } from "../../../../../../assets/images/icon/svg";
import CreateAction from "../../../../../../components/Actions/CreateAction";
import BulkAction from "../../../../../../components/Actions/BulkAction";
import { useTranslation } from "react-i18next";
import { useDocumentTypeLookup } from '../../../../../../hooks/lookups/useDocumentTypeLookup';


const initialState = {
    advancedSearch: false,
}

const UnionJournalSearchListFilter: FC<any> = props => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language || 'en';
    const { Search } = Input;
    const { Option } = Select;
    const { filters, handleOnChanged, handleCallbackFunc,
        librarysearchsubmiticon, onSubmit, onClickSearchBtn, onChangeKey, keyValue,filterLike } = props;

    const { loadingDocumentTypeLookupList, documentTypeLookupList } = useDocumentTypeLookup();
    const [advancedSearch, setAdvancedSearch] = useState(initialState.advancedSearch);



    return (
        <>
            <div className='library-search-content pt-5 pb-5'>
                <h3 className='h4 text-start'>{t('Journal Search, Find & Collect Information from National Union Catalogue')}</h3>
                <Form
                    onFinish={onSubmit}
                >
                    <div className="library-search-content-body green-search d-md-flex">
                        <div className="library-search-content-left">
                            <div className="library-search-dropdown">
                                <Form.Item name="language-code">
                                    <Select
                                        placeholder={t("All Document")}
                                        defaultValue={filters.document_type}
                                        onChange={(value) => handleOnChanged('filter_document_type', value)}
                                        bordered={false}>
                                        <Option value="alldocuments">{t("All Documents")}</Option>
                                        <Option value="journal">{t("Journal")}</Option>
                                        <Option value="library">{t("Library")}</Option>
                                        <Option value="city">{t("City")}</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='library-search-mid'>
                            <div className='d-flex justify-content-between library-search-content-middle'>

                                <Form.Item name="search" className='library-search-inputfiled' >
                                    <Search
                                        allowClear
                                        placeholder={t("Search")}
                                        onSearch={(value) => handleOnChanged('search', value, '')}
                                    />
                                </Form.Item>
                            </div>

                            <div className='library-search-extrainput'>
                                <Radio.Group  defaultValue={filterLike}>
                                    <Radio value={'contain'} onChange={(value) => handleOnChanged('filter_like', 'contain')} >{t('Contains')}</Radio>
                                    <Radio value={'exact'} onChange={(value) => handleOnChanged('filter_like', 'exact')} >{t('Exact')}</Radio>
                                    <Radio value={'startwith'} onChange={(value) => handleOnChanged('filter_like', 'startwith')} >{t('Starts with')}</Radio>
                                </Radio.Group>
                            </div>
                        </div>

                    </div>

                </Form>
            </div>
        </>


    );
}
export default React.memo(UnionJournalSearchListFilter);
